<script>
  import ExternalIcon from "../icons/external.svelte";
  // import externalIcon from "../assets/icons/external.svg";
  import { link } from "../util/anchor-link";
  export let italic = false;
  export let inline = false;
  export let href;
  export let icon = true;
  export let truncate = false;
</script>

<span>
  <a
    {href}
    use:link
    target="_blank"
    class:hasIcon={Boolean(icon)}
    class:externalLink={true}
    class:italic
    class:truncate
    class:inline
    ><slot></slot>{#if icon}
      <!-- <img class="icon" src={externalIcon} alt="" /> -->
      <ExternalIcon />
    {/if}</a
  ></span
>

<style>
  span {
    display: inline-block;
  }
  .italic {
    font-style: italic;
  }
  :global(.externalLink svg) {
    display: inline-block;
    height: 14px;
    position: relative;
    top: -1px;
    left: 1px;
    flex-shrink: 0;
    vertical-align: middle;
    white-space: nowrap;
  }
  .inline {
    display: inline-flex;
  }
  a {
    /* text-transform: uppercase; */
    /* background: beige; */
    /* padding: 0px 5px; */
    /* color: #1d1de0; */
    border-bottom: 1px solid black;
    /* margin: 0px -10px; */
    /* font-size: 14px; */
    font-weight: 400;
    /* border-radius: 2px; */
    /* color: white; */
    position: relative;
    text-decoration: none;
  }
  .hasIcon {
    /* display: inline-flex;
    justify-content: flex-start;
    align-items: center; */
  }
  a::after {
    /* content: " ";
    position: absolute;
    left: 0;
    bottom: 2px;
    width: 100%;
    height: 2px;
    background: black; */
  }
  .truncate {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
</style>
